import { h } from 'preact';
import * as BaseComp from 'components/bolt/footer/footer.js';
import IconicFooter from 'components/bolt/iconicFooter/iconicFooter';

export default class Footer extends BaseComp.default {
	render(props, state) {
		const { store, client, activePage } = props;
		const base = super.render(props, state);
		const iconicFooter = props?.data?.iconicFooter;

		if (iconicFooter) {
			return (
				<IconicFooter
					data={iconicFooter}
					appData={store.appData}
					activePage={activePage}
					client={client}
					store={store}
					scrollElem={props.scrollElem}
				/>
			);
		}

		return base;
	}
}